import { Paper } from '@mui/material';

export const PaperWithShadow = ({ children }: { children: React.ReactNode }) => (
  <Paper
    sx={(theme) => ({
      position: 'relative',
      zIndex: theme.zIndex.appBar,
      width: '100%',
      py: 1,
      px: 2,
      borderWidth: 0,
      boxShadow:
        '0 0 1px 1px rgba(0, 0, 0, 0.08), 0 2px 4px -1px rgba(0, 0, 0, 0.08), 0 2px 8px -2px rgba(0, 0, 0, 0.08)',
    })}
  >
    {children}
  </Paper>
);
